import { asyncStorageMethods } from '@/domain/shared/helpers/asyncStorageMethods';

type Reset = () => void;

export const reset: Reset = async () => {
  await asyncStorageMethods.removeItem('theme');
};
